function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";

const BookmarkOutline = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M5.5 21.385c0-.608-.862-1.098-1.375-.804l7.129-4.087.746-.427.746.427 7.129 4.087c-.514-.295-1.375.2-1.375.804V2.997c0 .278.226.503.5.503H5c.274 0 .5-.226.5-.503v18.388zM5 2h14c.552 0 1 .445 1 .997v18.388c0 .55-.386.775-.871.497L12 17.796l-7.129 4.086c-.48.276-.871.055-.871-.497V2.997C4 2.447 4.445 2 5 2z"
}, " "));

BookmarkOutline.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default BookmarkOutline;